<template>
    <v-card>
        <v-card-title class="justify-center">
            <v-btn icon style="position: absolute; left: 1em;" @click="$emit('fechar')">
                <v-icon>close</v-icon>
            </v-btn>
            <h1>CONFIGURAÇÕES SENDZAPI</h1>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="justify-center text-xs-center">
            <template v-if="mensagem">
                <v-icon :color="corMensagem" size="50">
                    {{ corMensagem === 'success' ? 'check_circle' : 'error' }}
                </v-icon>
                <h2 :class="corMensagem + '--text'" class="mt-3">
                    {{ mensagem }}
                </h2>
            </template>
            <template v-else-if="qrcode">
                <v-img :src="qrcode"></v-img>
            </template>
            <template v-else-if="!loading">
                <h2 class="success--text">Você já possui um conexão em um dispositivo</h2>
                <v-btn class="mt-4" color="error" @click="interromperConexao">
                    Interromper conexão
                </v-btn>
            </template>
            <template v-else>
                <v-progress-circular
                    indeterminate
                    :size="50"
                    color="info"
                ></v-progress-circular>
            </template>
            <v-spacer></v-spacer>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    data: () => ({
        qrcode: undefined,
        intervalo: null,
        mensagem: '',
        corMensagem: '',
        alerta: {
            tipo: 'error',
            texto: 'Esse tipo de veículo já foi cadastrado',
            ativo: false
        }
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        },
        smartLock () {
            return this.$store.getters.smartLock
        }
    },
    methods: {
        estabelecerConexao () {
            this.qrcode = undefined
            this.$store.dispatch('sendZapi', {
                method: 'GET'
            }).then(json => {
                if (json.value) {
                    this.qrcode = json.value
                } else {
                    this.qrcode = undefined
                    clearInterval(this.intervalo)
                }
            })
        },
        interromperConexao () {
            this.$store.dispatch('sendZapi', {
                method: 'DELETE'
            }).then(() => {
                this.mensagem = 'Conexão finalizada com sucesso'
                this.corMensagem = 'success'

                this.qrcode = undefined
                clearInterval(this.intervalo)

                setTimeout(() => {
                    this.mensagem = ''

                    this.estabelecerConexao()

                    this.intervalo = setInterval(() => {
                        this.estabelecerConexao()
                    }, 20000)
                }, 2000)
            }).catch((erro) => {
                this.mensagem = erro.message || 'Erro ao desconectar'
                this.corMensagem = 'error'
            })
        }
    },

    mounted () {
        this.estabelecerConexao()
        this.intervalo = setInterval(() => {
            this.estabelecerConexao()
        }, 20000)
    },

    beforeDestroy () {
        clearInterval(this.intervalo)
    }
}
</script>

<style>

</style>
